import { ApolloError, useMutation } from "@apollo/client";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import {
  ReviewCandidacyMutation as ReviewCandidacyMutationType,
  ReviewCandidacyMutationVariables,
} from "./__generated__/ReviewCandidacyMutation";

const ReviewCandidacyMutation = loader("./ReviewCandidacyMutation.gql");

type ReviewCandidacyMutationProviderType = (props: {
  children: (loading: boolean, mutate: any) => ReactNode;
  onError: (error: ApolloError) => void;
  onCompleted: (data: ReviewCandidacyMutationType) => void;
}) => ReactElement;

export const ReviewCandidacyMutationProvider: ReviewCandidacyMutationProviderType = (props) => {
  const { children, onError, onCompleted } = props;

  const [mutate, { loading }] = useMutation<ReviewCandidacyMutationType, ReviewCandidacyMutationVariables>(
    ReviewCandidacyMutation,
    {
      errorPolicy: "none",
      onError,
      onCompleted,
      refetchQueries: ["AbilitiesQuery"],
      awaitRefetchQueries: true,
    },
  );

  return <Fragment>{children(loading, mutate)}</Fragment>;
};
